import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import codemastersLogo from "assets/images/logos/logo_codemasters.png";
import LegalLinks from "./LegalLinks";
import NewTabLink from "components/links/NewTabLink";
import links from "links";
import Spacer from "components/Spacer";
import { footerItemHoverOpacity } from "theme";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            flex: "1 1 auto",
            flexDirection: "column",
            alignItems: "center",
        },
        logoContainer: {
            "&:hover": {
                opacity: footerItemHoverOpacity,
            },
        },
    })
);

export default function CodemastersSection() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <NewTabLink href={links.codemasters} className={classes.logoContainer}>
                <img src={codemastersLogo} alt="Codemasters Logo" style={{ width: 200 }} />
            </NewTabLink>
            <Spacer size={4} />
            <LegalLinks />
        </div>
    );
}
